import Rails from '@rails/ujs';
import { displaySpinner, hideSpinner } from './packs/application';

document.addEventListener("turbo:load", initializePromoCodeForms);
document.addEventListener("reinitializePromoCodeForms", initializePromoCodeForms);

function initializePromoCodeForms() {
  const applyPromoCodeButton = document.querySelector('#apply-promo-code');
  if (applyPromoCodeButton) setupPromoCodeForm(applyPromoCodeButton);
}

/**
 * Sets up the promo code form.
 * Attaches an event listener to the apply promo code button to handle the form submission.
 *
 * @param {HTMLElement} applyPromoCodeButton - The apply promo code button element.
 */
function setupPromoCodeForm(applyPromoCodeButton) {
  const spinner = applyPromoCodeButton.querySelector('.spinner-border');

  applyPromoCodeButton.addEventListener('click', function () {
    const promoCode = document.querySelector('#promo-code').value;
    const orderId = document.querySelector('input[name="payment_form[order][id]"]').value;

    const promoCodeFormData = {
      'promo_code_form[order_id]': orderId,
      'promo_code_form[promo_code]': promoCode
    };

    displaySpinner(spinner);
    applyPromoCodeButton.disabled = true;

    Rails.ajax({
      url: '/orders/promo_codes',
      type: 'POST',
      data: new URLSearchParams(promoCodeFormData).toString(),
      success: (data) => {
        hideSpinner(spinner);
        applyPromoCodeButton.disabled = false;

        if (data.error) {
          $('#promo-code-result').html('Erreur en appliquant le code promo : ' + data.error);
          $('#promo-code-result').removeClass('text-success');
          $('#promo-code-result').addClass('text-danger');
        } else {
          document.querySelector('#order-price-display').outerHTML = data.price_html;
          $('#promo-code-result').html("Bravo ! Tu bénéficies de " + data.data.percentage + "% de réduction");
          $('#promo-code-result').addClass('text-success');
          $('#promo-code-result').removeClass('text-danger');
        }
      },
      error: (data) => {
        hideSpinner(spinner);
        applyPromoCodeButton.disabled = false;
        $('#promo-code-result').html("As-tu oublié d'entrer ton code promo ?");
        $('#promo-code-result').removeClass('text-success');
        $('#promo-code-result').addClass('text-danger');
      }
    });
  });
};
